import React, { useEffect, useRef, useState } from "react";

/**
 * Defers mounting heavy children until they are near viewport.
 * Inputs: immediate, rootMargin, children. Output: rendered children or placeholder.
 */
function VisibilityGate({
  children,
  immediate = false,
  rootMargin = "300px 0px",
  placeholder = null,
}) {
  const hostRef = useRef(null);
  const [isVisible, setIsVisible] = useState(immediate);

  useEffect(() => {
    if (immediate) {
      setIsVisible(true);
      return;
    }

    if (!hostRef.current || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry?.isIntersecting) {
          setIsVisible(true);
          // One-shot gate: once mounted, keep children mounted.
          observer.disconnect();
        }
      },
      { rootMargin },
    );

    observer.observe(hostRef.current);
    return () => observer.disconnect();
  }, [immediate, rootMargin]);

  return <div ref={hostRef}>{isVisible ? children : placeholder}</div>;
}

export default VisibilityGate;
